import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeFormDataDto implements IEmployeeFormDataDto {
    employee!: EmployeeSummaryDto;
    mobileNo!: string | undefined;
    pan!: string | undefined;
    grossSalary!: number | undefined;
    investmentAmount!: number | undefined;
    investmentMaxAllowAmount!: number | undefined;
    financialYear!: string | undefined;
    itMethod!: string | undefined;
    fromDate!: Date;
    toDate!: Date;
    tdsFinalAmount!: number | undefined;
    professionalTax!: number | undefined;

    constructor(data?: IEmployeeFormDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.mobileNo = _data["mobileNo"];
            this.pan = _data["pan"];
            this.grossSalary = _data["grossSalary"];
            this.investmentAmount = _data["investmentAmount"];
            this.investmentMaxAllowAmount = _data["investmentMaxAllowAmount"];
            this.financialYear = _data["financialYear"];
            this.itMethod = _data["itMethod"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.tdsFinalAmount = _data["tdsFinalAmount"];
            this.professionalTax = _data["professionalTax"];
        }
    }

    static fromJS(data: any): EmployeeFormDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeFormDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["mobileNo"] = this.mobileNo;
        data["pan"] = this.pan;
        data["grossSalary"] = this.grossSalary;
        data["investmentAmount"] = this.investmentAmount;
        data["investmentMaxAllowAmount"] = this.investmentMaxAllowAmount;
        data["financialYear"] = this.financialYear;
        data["itMethod"] = this.itMethod;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["tdsFinalAmount"] = this.tdsFinalAmount;
        data["professionalTax"] = this.professionalTax;
        return data; 
    }
}

export interface IEmployeeFormDataDto {
    employee: EmployeeSummaryDto;
    mobileNo: string | undefined;
    pan: string | undefined;
    grossSalary: number | undefined;
    investmentAmount: number | undefined;
    investmentMaxAllowAmount: number | undefined;
    financialYear: string | undefined;
    itMethod: string | undefined;
    fromDate: Date;
    toDate: Date;
    tdsFinalAmount: number | undefined;
    professionalTax: number | undefined;
}

